import React from "react";
import styles from "./WelcomeMessage.module.css"
import image from "../../../../images/LOGO.svg"

function WelcomeMessage() {
  return (
    <div className={styles.welcome_wrapper}>
      <div className={styles.welcome}>
        <div className={styles.welcome_image}>
          <div className={styles.welcomeimagebg}>
            <img
              src={image}
              className={styles.welcome_image_img}
              alt="Employee Assist Logo"
            />
          </div>
        </div>

        <div className={styles.welcome_message}>
          <p className={styles.welcome_message_first}>
            Hi! Welcome to Indian Bank, I am ADYA
            <span className={styles.welcome_message_first_underline}></span>
          </p>
          <p className={styles.welcome_message_mid}>
            How may I assist you today!
          </p>
          {/* <p className={styles.welcome_message_last}>You can either choose a category or type your query below.</p> */}
        </div>
      </div>
    </div>
  );
}

export default WelcomeMessage;
